/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { action } from 'typesafe-actions';
import { AuthToken } from './../../graphql/types/types.d';
import {
  doHandleApplicationStarted,
  doLoginFirst,
  doLoginSecond,
  doLogout,
  doSetAuthenticationToken,
  doPostponeTimeout,
} from './auth-thunk-actions';

export const actionTypes = {
  DO_LOGIN: 'Auth/DoLogin',
  DO_HANDLE_ALREADY_LOGGED_IN: 'Auth/DoHandleAlreadyLoggedIn',
  SET_USER_LOGGED_IN: 'Auth/SetUserLoggedIn',
  SET_USER_LOGGED_OUT: 'Auth/SetUserLoggedOut',
  SET_LOGIN_REDIRECT_PATH: 'Auth/SetLoginRedirectPath',
  SET_LANGUAGE: 'Auth/SetLanguage',
  SET_FIRST_TOKEN: 'Auth/SetFirstToken',
  SET_AUTH_TOKEN: 'Auth/SetAuthToken',
  SET_FINISHED_CONFIRMATION: 'Auth/SetFinishedConfirmation',
  SET_TIMEOUT_TIMESTAMP: 'Auth/SetTimeoutTimestamp',
  SET_REMAINING_TIME: 'Auth/SetRemainingTime',
  SET_LOGIN_ERROR: 'Auth/SetLoginError',
  RESET_STORE: 'Auth/ResetStore',
  SET_SHOULD_RESET_CLIENT: 'Auth/SetShouldResetClient',
  SET_AUTH_TOKEN_ACCEPT_TERMS: 'Auth/SetAuthTokenAcceptTerms',
};

export const actions = {
  setUserLoggedIn: () => action(actionTypes.SET_USER_LOGGED_IN),
  setUserLoggedOut: () => action(actionTypes.SET_USER_LOGGED_OUT),
  setLoginRedirectPath: (path?: string) => action(actionTypes.SET_LOGIN_REDIRECT_PATH, path),
  setFirstToken: (token?: string) => action(actionTypes.SET_FIRST_TOKEN, token),
  setAuthToken: (token?: AuthToken) => action(actionTypes.SET_AUTH_TOKEN, token),
  setAuthTokenAcceptTerms: () => action(actionTypes.SET_AUTH_TOKEN_ACCEPT_TERMS),
  setTimeoutTimestamp: (timestamp?: Date) => action(actionTypes.SET_TIMEOUT_TIMESTAMP, timestamp),
  setRemainingTime: (time?: number) => action(actionTypes.SET_REMAINING_TIME, time),
  setLoginError: (key: string, value: string | undefined) =>
    action(actionTypes.SET_LOGIN_ERROR, { key, value }),
  setFinishedConfirmation: (finished: boolean) =>
    action(actionTypes.SET_FINISHED_CONFIRMATION, finished),
  resetStore: () => action(actionTypes.RESET_STORE),
  setShouldResetClient: (reset: boolean) => action(actionTypes.SET_SHOULD_RESET_CLIENT, reset),
  setLanguage: (language: string) => action(actionTypes.SET_LANGUAGE, language),

  doLoginFirst,
  doLoginSecond,
  doLogout,
  doHandleApplicationStarted,
  doSetAuthenticationToken,
  doPostponeTimeout,
};
